<div bsModal #transactionPopup="bs-modal" [config]="modalConfig" class="modal fade" tabindex="-1" role="dialog"
  aria-labelledby="dialog-sizes-name1">
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content">
      <form #printform="ngForm">
        <div class="modal-body">
          <div class="row mx-0">
            <div class="payment_successful_txt">
              <app-success-tick></app-success-tick><br><span>Transaction Success</span>
            </div>
          </div>
          <div class="row  justify-content-between">
            <div class="col-md-4">
              <label class="pure-material-checkbox">
                <input type="checkbox" class="custom-control-input" [(ngModel)]="isEmailChecked" name="isEmailChecked"
                  [disabled]="isEmailDisabled" (change)="onEmailCheck($event)">
                  <span>Email</span>
                </label>
                <div class="row mx-0 mt-2">
                  <input type="text" class="form-control" name="email" [(ngModel)]="emailBox" [pattern]="emailPattern"
                    #email="ngModel" [title]="emailBox" [required]="isEmailChecked" [disabled]="!enableEmail || isEmailDisabled">
                    @if (email.errors !== null &&((email.dirty ||email.touched) || isEmailChecked)) {
                      <div class="alert alert-danger"
                        >
                        @if (email.errors.pattern) {
                          <span i18n="@@Email_Error"> Enter valid E-Mail Id <br>
                  </span>
                        }
                        @if (email.errors.required) {
                          <span>E-mail Id is required</span>
                        }
                      </div>
                    }
                  </div>
                  @if (emailTemplates.length) {
                    <div class="row mx-0 mt-2">
                      <select class="form-select" (change)="onChangeEmailTemplate($event.target.value)">
                        @for (emailTemp of emailTemplates; track emailTemp) {
                          <option [value]="emailTemp.LetterId" [selected]="emailTemp.DefaultTemplate"
                          >{{emailTemp.LetterName}}</option>
                        }
                      </select>
                    </div>
                  }
                </div>
                <div class="col-md-4 doc_opt">
                  <label class="pure-material-checkbox checkbox-Margin">
                    <input type="checkbox" class="custom-control-input" [(ngModel)]="isSMSChecked" name="isSMSChecked"
                      (change)="onsmscheck($event)" [disabled]="isSmsDisabled">
                      <span>SMS</span>
                    </label>
                    <div class="mt-2 outer_border">
                      <ejs-maskedtextbox [mask]="PhoneNumberMask" name="sms" id="inputCellPhone" [disabled]="!enablesms"
                        [(ngModel)]="phoneNumber" [readonly]="true">
                      </ejs-maskedtextbox>
                    </div>
                    @if (smsTemplates.length) {
                      <div class="mt-2">
                        <select class="form-select" (change)="onChangeSMSTemplate($event.target.value)">
                          @for (smsTemp of smsTemplates; track smsTemp) {
                            <option [value]="smsTemp.LetterId" [selected]="smsTemp.DefaultTemplate"
                            >{{smsTemp.LetterName}}</option>
                          }
                        </select>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </form>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" data-dismiss="modal" (click)="goToHost()">OK</button>
            </div>
          </div>
        </div>
      </div>